<template>
  <div>
    <h1>角色管理</h1>
    <div style="text-align:right;margin-bottom:10px;">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="showRole()">创建角色</el-button>
      <el-button type="primary" icon="el-icon-document-checked" @click="saveAuthorityToRole()">保存权限</el-button>
    </div>
    <div class="role-manager">
      <!-- 角色列表 -->
      <div class="role-list">
        <h2>角色列表</h2>
        <ul class="roleList">
          <li
            v-for="(item, index) in roleList"
            :key="index"
            :class="{'active':index==isIndex}"
            @click="tabRole(index)"
          >
            {{item.roleName}}
            <p class="fun">
              <span class="el-icon-edit-outline" title="修改" @click="showRole(item)"></span>
              <span class="el-icon-delete" title="删除" @click="delRole(item)"></span>
            </p>
          </li>
        </ul>
      </div>
      <div class="role-power">
        <h2>角色权限</h2>
        <div class="content">
          <header class="header">
            <span class="list">分类</span>
            <span class="power">权限</span>
          </header>
          <ul>
            <li v-for="item in 1">
              <span class="list">
                <el-checkbox v-model="checked" @change="allSelect()">接口权限</el-checkbox>
              </span>
              <div class="power powers">
                <el-checkbox
                  v-model="item.isSelected"
                  v-for="(item,index) in authorityList"
                  :key="index"
                >{{item.authorityName}}</el-checkbox>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <el-dialog title="新增/修改角色" :visible.sync="dialogVisible" width="440px">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="角色名称:">
          <el-input v-model="form.roleName" style="width:240px"></el-input>
        </el-form-item>
        <el-form-item label="角色描述:">
          <el-input v-model="form.roleScript" style="width:240px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  AddOrUpdateRoles,
  RemoveRoles,
  GetCurUserAllRoleList,
  GetOwnAuthorityList,
  GetRoleAuthoritiesByRoleId,
  AddShopUserRalation,
  RemoveShopUserRalation,
  SetRoleAuthorities
} from "@/utils/api";
export default {
  data() {
    return {
      checked: "",
      isIndex: 0,
      dialogVisible: false,
      authorities: [],
      roleList: [],
      authorityList: [],
      form: {
        roleId: -1
      }
    };
  },
  methods: {
    //角色列表
    getRoleList() {
      GetCurUserAllRoleList().then(res => {
        if (res) {
          this.roleList = res;
          this.getOwnAuthorityList();
        }
      });
    },
    //权限列表
    getOwnAuthorityList() {
      this.authorityList = [];
      GetOwnAuthorityList().then(res => {
        if (res) {
          res.forEach(v => {
            this.authorityList.push({
              ...v,
              isSelected: false
            });
          });
          this.getRoletoAuthority();
        }
      });
    },
    //切换角色
    tabRole(index) {
      this.isIndex = index;
      this.checked = false;
      this.getRoletoAuthority();

    },
    //全选
    allSelect(){
      if( this.checked ){
        this.authorityList.forEach((v,i)=>{
          this.$set(this.authorityList[i], "isSelected", true)
       })
      }else{
        this.authorityList.forEach((v,i)=>{
          this.$set(this.authorityList[i], "isSelected", false)
       })
      }
    },

    //获取角色权限接口
    getRoletoAuthority() {
      let roleId = this.roleList[this.isIndex].roleId;
       this.authorityList.forEach((v,i)=>{
          this.$set(this.authorityList[i], "isSelected", false)
       })

      GetRoleAuthoritiesByRoleId({
        roleId
      }).then(res => {
        this.authorityList.forEach((v, i) => {
          if (res[0].authorities.length > 0) {
            res[0].authorities.forEach((v1, i1) => {
              if (v.authorityId == v1.authorityId) {
                this.authorityList[i].isSelected = true;
              }
            });
          }
        });
      });
    },
    //为角色授权
    saveAuthorityToRole() {
      let RoleId = this.roleList[this.isIndex].roleId;
      var AuthorityIds = [];
      this.authorityList.forEach((v, i) => {
        if (v.isSelected) {
          AuthorityIds.push(v.authorityId);
        }
      });

      SetRoleAuthorities({
        AuthorityIds,
        RoleId
      }).then(res => {
        if (res) {
          this.$message.success("角色绑定权限成功");
        }
      });
    },
    //弹出角色弹框
    showRole(item) {
      if (item) {
        this.form = JSON.parse(JSON.stringify(item));
      } else {
        this.form = {
          roleId: -1
        };
      }

      this.dialogVisible = true;
    },
    //提交角色
    submit() {
      if (!this.form.roleName) {
        this.$message.error("角色名称不能为空");
        return;
      }

      AddOrUpdateRoles(this.form).then(res => {
        if (res) {
          if (this.form.roleId == "-1") {
            this.$message.success("角色新增成功");
          } else {
            this.$message.success("角色修改成功");
          }
          this.dialogVisible = false;
          this.getRoleList();
        }
      });
    },
    delRole(item) {
      this.$confirm("此操作将删除该角色, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          RemoveRoles({
            RoleId: item.roleId
          }).then(res => {
            if (res) {
              this.$message({
                type: "success",
                message: "删除角色成功!"
              });
              this.getRoleList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },

  created() {
    this.getRoleList();
  }
};
</script>

<style lang="less" scoped>
h1 {
  font-size: 20px;
  padding: 20px 0;
}
.role-manager {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  .role-list {
    width: 20%;
    min-height: 70vh;
    background: #fff;
    border: 1px solid #ebedf8;
    border-radius: 10px;
    ul {
      border-bottom: 1px solid #e5e5e5;
      li {
        padding: 20px 20px 20px 40px;
        border-top: 1px solid #e5e5e5;
      }
    }
  }
  .role-power {
    width: 78%;
    min-height: 70vh;
    background: #fff;
    border: 1px solid #ebedf8;
    border-radius: 10px;
    .content {
      border: 1px solid #e5e5e5;
      margin: 20px;
      margin-top: 0;
    }
    .list {
      width: 20%;
      padding: 20px;
    }
    .power {
      width: 80%;
      padding: 20px;
      border-left: 1px solid #e5e5e5;
    }
    .header,
    ul li {
      display: flex;
      display: -webkit-flex;
      border-bottom: 1px solid #e5e5e5;
      align-items: center;
    }
    .header {
      font-weight: bold;
    }
    ul li {
      &:last-child {
        border: 0;
      }
      .powers {
        display: flex;
        display: -webkit-flex;
        flex-wrap: wrap;
        /deep/ .el-checkbox {
          margin-top: 5px;
          margin-bottom: 5px;
          width:45%;
        }
      }
    }
  }
  h2 {
    padding: 20px;
    color: #333;
    font-size: 18px;
  }
  .roleList {
    li {
      position: relative;
      &.active {
        background: #eee;
      }
      .fun {
        position: absolute;
        top: 20px;
        right: 20px;
        span {
          font-size: 16px;
          &.el-icon-edit-outline {
            color: #3a8ee6;
          }
          &.el-icon-delete {
            color: red;
            margin-left: 10px;
          }
        }
      }
    }
  }
}
</style>